import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var tableId = 'tableConfigurationImportResult';
var FILTER_DELIM = '-delim-';

var COLUMNS_INDEX = {
    CustomerCode: 0,
    CurrencyCode: 1,
    GameCode: 2,
    Result: 3
}

export interface ResultPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class ResultPage extends PageBase<ResultPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _detailRowsIds: Array<string>;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;

    private _filterGames: MultiSelectApi;
    private _filterCurrencies: MultiSelectApi;
    private _filterCustomers: MultiSelectApi;
    private _filterResults: MultiSelectApi;

    constructor(options: ResultPageOptions) {
        super(options);

        // initialize detail rows
        this._detailRowsIds = [];

        // === bind event methods to this instance
        this.createdRow = this.createdRow.bind(this);
        this.renderDetailRow = this.renderDetailRow.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            //scrollX: true,
            rowId: 'Id',
            autoWidth: false,
            pageLength: -1,
            fixedHeader: {
                header: true,
                headerOffset: 50
            },
            order: [3, "asc"],
            columns: [
                {
                    data: "CustomerCode"
                },
                {
                    data: "CurrencyCode"
                },
                {
                    data: "GameCode"
                },
                {
                    data: "Result"
                }
            ],
            rowDetail: {
                hasDetail: true,
                render: this.renderDetailRow
            },
            callbacks: {
                preDrawCallback: this.preDrawCallback,
                createdRow: this.createdRow
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formConfigurationImportResult");
        this._btnCancelSearch = Utils.getJQueryById('btnCancelSearch');
        this._filterCustomers = new MultiSelectApi("filterCustomers");
        this._filterCurrencies = new MultiSelectApi("filterCurrencies");
        this._filterGames = new MultiSelectApi("filterGames");
        this._filterResults = new MultiSelectApi("filterResults");
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
        this._form.on('submit', this.formSubmit);
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterCustomers.selectAll();
        this._filterCurrencies.selectAll();
        this._filterGames.selectAll();
        this._filterResults.selectAll();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterCustomer = this._filterCustomers.isAllSelected() ? '' : this._filterCustomers.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.CustomerCode).search(filterCustomer);
        var filterCurrency = this._filterCurrencies.isAllSelected() ? '' : this._filterCurrencies.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.CurrencyCode).search(filterCurrency);
        var filterGame = this._filterGames.isAllSelected() ? '' : this._filterGames.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.GameCode).search(filterGame);
        var filterResult = this._filterResults.isAllSelected() ? '' : this._filterResults.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Result).search(filterResult);
    }

    private createdRow(row: Node, data: any[] | Object, dataIndex: number): void {
        $('td', row).addClass('cursor-pointer');

        if (data["Result"] === "Failed") {
            $(row).addClass('error-log-row');
        }
    }

    private renderDetailRow(data: any): string {
        
        var result = '';

        if (!StringUtils.isNullOrEmpty(data.Error)) {
            result = `<div class='note note-danger'>
                    <h5>Exception</h5>
                    <p class="errorLogContextData">${_.escape(data.Error)}</p>
                    <p>&nbsp;</p>
                    </div>`;
        } else {
            result = `<div class='note'>
                    <p class="jsonContextData">${_.escape(JSON.stringify(JSON.parse(data.Configuration)))}</p>
                    <p>&nbsp;</p>
                    </div>`;
        }

        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundConfigurationImport/ResultPage.ts
 **/